<template>
  <base-edit :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs" />
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "questionnaires",
      fields: [
        {
          label: "アンケート名",
          name: "form_title",
          rules: "required|max:255",
          width: "60%"
        },
        {
          label: "アンケートページURL",
          name: "url",
          rules: "required",
          width: "60%"
        },
        {
          label: "公開期間 from",
          name: "publish_from",
          rules: "lessThanEqual:@publish_to",
          type: "date"
        },
        {
          label: "公開期間 to",
          name: "publish_to",
          rules: "greaterThanEqual:@publish_from",
          type: "date"
        },
        {
          label: "概要",
          name: "description",
          type: "custom",
          width: "60%"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "アンケート一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "アンケート編集",
          disabled: true
        }
      ];
    }
  }
};
</script>
